import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CmsTarget, CmsTeaser } from '@fcom/core-api';

import { toLinkData } from '../../services';

@Component({
  selector: 'cms-cta-big-link',
  template: `
    <fin-cta-big-link
      [target$]="cmsTarget$"
      [teaserTitle$]="content$ | finMap: 'teaserTitle'"
      [teaserText$]="content$ | finMap: 'teaserText'"
      class="mr-medium-t mr-xlarge-b block"
    />
  `,
  styleUrls: ['./cms-cta-big-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsCtaBigLinkComponent implements OnInit {
  @Input()
  content$: Observable<CmsTeaser>;

  cmsTarget$: Observable<CmsTarget>;

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));
  }
}
